import { render, staticRenderFns } from "./BookingAmount.vue?vue&type=template&id=baf2ada0"
import script from "./BookingAmount.vue?vue&type=script&lang=js"
export * from "./BookingAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports